export default "__VITE_ASSET__DFyfCuXj__"